import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { projectPackageListingStatus } from "../../redux/features/mastersSlice";

export const ProjectPackageListingStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.isListed}
                api={projectPackageListingStatus(params.packageId)}
            />
        </div>
    );
};
